import AntdImage    from 'antd/lib/image';
import React        from 'react';
import Spin         from '@widesk-ui/components/Spin';
import useTheme     from '@widesk-ui/hooks/useTheme';
import { Skeleton } from 'antd';

export type ImageProps = {
	src?: string;
	height?: number | string;
	width?: number | string;
	style?: React.CSSProperties;
	fit?: 'contain' | 'cover' | 'fill'; // Default contain
	borderRadius?: number;
	preview?: boolean;
	loading?: boolean;
	bordered?: boolean;
	size?: ImageSize;
	placeholder?: boolean; // when loading is over but src is empty we can display a placeholder or nothing
	crossOrigin?: '' | 'anonymous' | 'use-credentials';
};

const sizes: Record<ImageSize, number> = {
	small: 20,
	middle: 44,
	large: 80,
	extralarge: 100,
};

const Image = (props: ImageProps) => {
	const { borderRadius, loading, src, size, bordered, placeholder } = props;
	const theme = useTheme();

	const fit = props.fit || 'contain';

	const width = size ? sizes[size] : props.width;
	const height = size ? sizes[size] : props.height;

	const borderStyleValue = bordered ? `1px solid ${theme.colorBorder}` : undefined;

	const SkeletonImage = (props: {active?: true}) => (
		<Skeleton.Image active={props.active} style={{
			borderRadius: borderRadius || 0,
			padding: borderRadius ? borderRadius / 3 : undefined,
			border: borderStyleValue,
			height: height ?? height,
			width: width ?? width,
			overflow: 'hidden',
		}} />
	);

	return (
		<Spin size="small" spinning={!!loading} style={{ lineHeight: 1 }}>
			{((typeof src === 'undefined') || (placeholder && !loading && !src))
				? <SkeletonImage />
				: (
					<AntdImage
						loading="lazy"
						style={{
							borderRadius: borderRadius || 0,
							objectFit: fit,
							border: borderStyleValue,
							...props.style,
						}}
						placeholder={<SkeletonImage active/>}
						preview={props.preview && !!src}
						src={src}
						crossOrigin={props.crossOrigin}
						width={width}
						height={height}
					/>
				)
			}
		</Spin>
	);
};

Image.sizes = sizes;

export default Image;
